// src/components/SimpleDashboard.tsx
import React from 'react';

interface SimpleDashboardProps {
  onCustomerSearchClick?: () => void;
  onEventsClick?: () => void;
  user?: any;
  signOut?: () => void;
}

const SimpleDashboard: React.FC<SimpleDashboardProps> = ({ 
  onCustomerSearchClick,
  onEventsClick,
  user,
  signOut
}) => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <div className="flex items-center">
              <h1 className="text-2xl font-bold text-gray-900">
                🔐 Lookey Admin
              </h1>
              <span className="ml-3 px-2 py-1 text-xs font-medium bg-green-100 text-green-800 rounded">
                LIVE
              </span>
            </div>
            <div className="flex items-center space-x-4">
              <div className="text-sm text-gray-500">
                Environment: {import.meta.env.VITE_ENVIRONMENT || 'development'}
              </div>
              {user && (
                <div className="flex items-center space-x-3">
                  <span className="text-sm text-gray-600">
                    {user.attributes?.email}
                  </span>
                  <button
                    onClick={signOut}
                    className="text-sm text-red-600 hover:text-red-800"
                  >
                    Sign Out
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        
        {/* Quick Actions Section */}
        <div className="bg-white rounded-lg shadow p-6 mb-8">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">Quick Actions</h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            
            <button 
              onClick={onCustomerSearchClick}
              className="flex items-center justify-center px-4 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
            >
              <span className="text-xl mr-2">🔍</span>
              <span className="font-medium">Search Customers</span>
            </button>
            
            <button 
              onClick={onEventsClick}
              className="flex items-center justify-center px-4 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
            >
              <span className="text-xl mr-2">📊</span>
              <span className="font-medium">View Events</span>
            </button>
            
            <button className="flex items-center justify-center px-4 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors opacity-50 cursor-not-allowed">
              <span className="text-xl mr-2">🎫</span>
              <span className="font-medium">All Tickets</span>
              <span className="ml-1 text-xs text-gray-500">(Soon)</span>
            </button>
            
            <button className="flex items-center justify-center px-4 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors opacity-50 cursor-not-allowed">
              <span className="text-xl mr-2">👥</span>
              <span className="font-medium">All Providers</span>
              <span className="ml-1 text-xs text-gray-500">(Soon)</span>
            </button>
            
          </div>
        </div>

        {/* Welcome Message */}
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
          <div className="flex items-start">
            <div className="flex-shrink-0">
              <span className="text-2xl">👋</span>
            </div>
            <div className="ml-3">
              <h3 className="text-lg font-medium text-blue-900">
                Welcome to Lookey Admin
              </h3>
              <p className="mt-2 text-blue-700">
                Use the quick actions above to search customers, view system events, 
                or manage tickets and providers. This dashboard will evolve as we 
                identify the most useful metrics and tools.
              </p>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default SimpleDashboard;